var map = {
	"./Co2.svg": 630,
	"./Community.svg": 7351,
	"./Dashboard.svg": 7352,
	"./ESGReports.svg": 7353,
	"./ESG_Frameworks.svg": 7354,
	"./Environment.svg": 7355,
	"./Governance.svg": 7356,
	"./Marketplace.svg": 7357,
	"./Purpose.svg": 7358,
	"./Settings.svg": 7359,
	"./Workplace.svg": 7360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 504;